import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { isMobile } from 'react-device-detect';


/* Mui Tooltip wrapper component */
const Tip = ({ children, title, ...props }) => {
  return !title ? (
    children
  ) : (
      <Tooltip
        sx={isMobile?{
          fontSize: '0.8rem',
          paddingRight: '0.5rem',
          paddingBottom: '1rem' ,
        }:{
          fontSize: '0.8rem',
          padding: '0.5rem',
          marginBottom: '1rem'
        }
        }
        enterDelay={300}
        enterTouchDelay={10}
        placement="top"
        arrow
        title={title}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {children}
      </Tooltip>
  );
};

Tip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
};

Tip.defaultProps = {
  title: null,
};

export default Tip;
